const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/index.vue"),
  },
  {
    path: "/home/tenant/",
    name: "home",
    component: () => import("../views/layout/index.vue"),
    children: [
      {
        path: "/home/tenant/:ParkLotId",
        name: "rtView",
        component: () => import("../views/realtimeView/index.vue"),
        children:[{
          path:'/home/tenant/:ParkLotId/:ParkLotName/:GateId/:GateName',
          name:'rtLive',
          component:()=>import("../serviceComponents/realtimeVideo.vue")
        }]
      },
      // {
      //   path: "/home/tenant/:ParkLotId/:SentryBoxId",
      //   name: "rtView",
      //   component: () => import("../views/realtimeView/index.vue"),
      // },
    ],
  },
  {
    path: "/ZS/tenant/",
    name: "home",
    component: () => import("../views/layout/index.vue"),
    children: [
      {
        path: "/ZS/tenant/:ParkLotId",
        name: "rtView",
        component: () => import("../views/zsRetimeView/index.vue"),
        children:[{
          path:'/ZS/tenant/:ParkLotId/:ParkLotName/:GateId/:GateName',
          name:'zsrtLive',
          component:()=>import("../serviceComponents/realtimeVideo.vue")
        }]
      },
      // {
      //   path: "/home/tenant/:ParkLotId/:SentryBoxId",
      //   name: "rtView",
      //   component: () => import("../views/realtimeView/index.vue"),
      // },
    ],
  },
];
export default routes;
